import React from "react";

// ===================================================================
// The Crowd v2 — Graphique a barres horizontales
//
// Composant partage (Change Management, Mes tickets...). Aucun appel
// API : la page fournit les donnees. Styles dans v2-composants.css ;
// seule la largeur de chaque barre est calculee ici, c'est une donnee.
//
// Props :
//   data        [{ ... }] — une ligne par barre
//   labelKey    cle du libelle dans chaque ligne
//   valueKey    cle de la valeur dans chaque ligne
//   libelles    { valeurBrute: "Libelle affiche" } — optionnel
//   tonalites   { valeurBrute: "danger" | "warning" | "success" | "neutre" }
//               — optionnel ; couleur de feedback par barre, "neutre" sinon
// ===================================================================

const TONALITES = ["danger", "warning", "success", "neutre"];

function GraphiqueBarres({ data, labelKey, valueKey, libelles = {}, tonalites = {} }) {
  if (!data || data.length === 0) {
    return <p className="v2-vide">Aucune donnée</p>;
  }

  const maxVal = Math.max(...data.map((d) => d[valueKey]));

  return (
    <ul className="v2-barres">
      {data.map((d, i) => {
        const brut = d[labelKey];
        const label = libelles[brut] || brut || "Non défini";
        const value = d[valueKey];
        const largeur = maxVal > 0 ? (value / maxVal) * 100 : 0;
        const ton = TONALITES.includes(tonalites[brut]) ? tonalites[brut] : "neutre";
        return (
          <li key={i} className="v2-barres-ligne">
            <span className="v2-barres-libelle" title={label}>{label}</span>
            <span className="v2-barres-piste">
              <span className={`v2-barres-valeur v2-ton-${ton}`} style={{ width: `${largeur}%` }} />
            </span>
            <span className="v2-barres-nombre">{value}</span>
          </li>
        );
      })}
    </ul>
  );
}

export default GraphiqueBarres;
